/* Small enhancements; checkout and cart operations stay in Shopify/Dawn. */
if (!customElements.get('fz-countdown')) {
  customElements.define('fz-countdown', class extends HTMLElement {
    connectedCallback() {
      // Require an explicit timezone. Invalid/expired campaigns never show urgency.
      this.end = /(?:Z|[+-]\d{2}:\d{2})$/.test(this.dataset.end || '') ? Date.parse(this.dataset.end) : NaN;
      this.tick();
      if (!this.hidden) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const seconds = Math.ceil((this.end - Date.now()) / 1000);
      this.hidden = !Number.isFinite(seconds) || seconds <= 0;
      if (this.hidden) { clearInterval(this.timer); return; }
      const hours = Math.floor(seconds / 3600);
      this.querySelector('b').textContent = [hours, Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
    }
  });
}
if (!customElements.get('fz-sticky-cart')) {
  customElements.define('fz-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.owner = this.closest('product-info');
      this.button = this.querySelector('[data-sticky-submit]');
      if (!this.owner || !this.button) return;
      this.sync = this.sync.bind(this);
      this.onClick = () => {
        const submit = this.owner.querySelector('product-form [type="submit"]');
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        // Use the original form: selected variant, quantity, gift fields and apps stay in sync.
        const form = submit.form;
        if (!form.checkValidity()) {
          form.reportValidity();
          form.scrollIntoView({block:'center', behavior:'smooth'});
          return;
        }
        submit.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.contains(r.target))) this.sync();
      });
      this.observer.observe(this.owner, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','class']});
      this.intersection = new IntersectionObserver(entries => {
        this.mainVisible = entries[0].isIntersecting;
        this.updateVisibility();
      }, {threshold:0});
      this.sync();
      document.body.classList.add('fz-has-sticky-cart');
    }
    sync() {
      const submit = this.owner.querySelector('product-form [type="submit"]');
      if (!submit) { this.hidden = true; return; }
      if (submit !== this.mainButton) {
        this.intersection.disconnect();
        this.mainButton = submit;
        this.intersection.observe(submit);
      }
      this.button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      const label = submit.querySelector('span')?.textContent.trim() || submit.textContent.trim();
      if (this.button.textContent !== label) this.button.textContent = label;
      const price = this.owner.querySelector('[id^="price-"] .price-item--sale')?.closest('.price--on-sale')?.querySelector('.price-item--sale')
        || this.owner.querySelector('[id^="price-"] .price__regular .price-item--regular');
      const output = this.querySelector('[data-sticky-price]');
      const value = price?.textContent.trim() || '';
      if (output.textContent !== value) output.textContent = value;
      this.updateVisibility();
    }
    updateVisibility() { this.hidden = !this.mainButton || !!this.mainVisible; }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      document.body.classList.remove('fz-has-sticky-cart');
    }
  });
}
